<template>
  <div class="empallrequestsexport" v-if="user.isAdmin">
    <div class="container-fluid">
      <div class="container-fluid pb-3">
        <h2 class="card-title font-weight-bold">All Requests</h2>

        <div class="card-deck mb-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title mb-1">Data Filter</h5>
              <table border="0" cellspacing="5" cellpadding="5">
                <tbody>
                  <tr>
                    <td>Start Date:</td>
                    <td>
                      <input
                        v-model="startDate"
                        type="date"
                        id="fini"
                        name="fini"
                        @change="resetPage"
                      />
                    </td>
                    <td>City:</td>
                    <td>
                      <div class="form-group">
                        <input
                          type="City"
                          class="form-control"
                          aria-describedby="citySearch"
                          v-model="cityVal"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>End Date:</td>
                    <td>
                      <input
                        v-model="endDate"
                        type="date"
                        id="ffin"
                        name="ffin"
                        @change="resetPage"
                      />
                    </td>
                    <td>Bulk Type:</td>
                    <td>
                      <select
                        v-model="req_type"
                        class="form-control mb-2"
                        required
                      >
                        <option v-for="type in sortBulkTypes(bulkTypes, true)" :key="type.id">{{type.name}}</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Export Requests</h5>
              <p class="card-text">
                Utilize the filters on the left to curate the data to meet your
                export needs.
              </p>
              <p class="card-text">
                The search box can also be used to return more refined or
                specific results prior to exporting.
              </p>
              <br />
              <div>
                <button
                  @click="exportCSVFile()"
                  type="button"
                  class="btn btn-outline-success"
                  style="
                    font-size: 15px;
                    padding: 5px 10px;
                    margin: auto;
                    margin-top: -3px;
                    margin-left: 10px;
                    margin-bottom: 10px;
                  "
                >
                  Export Data <i class="fas fa-file-export ml-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <RequestTable
          ref="RequestTable"
          :requests="allRequests"
          :startDate="startDate"
          :endDate="endDate"
          :type="req_type"
          :city="cityVal"
          :shortTable="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RequestTable from "../components/RequestTable.vue";
import { mapState, mapGetters } from "vuex";
import Vuetable from "vuetable-2";

export default {
  name: "EmpAllRequestsExport",
  components: { RequestTable },
  props: {},
  data() {
    return {
      startDate: null,
      endDate: new Date().toISOString().slice(0, 10),
      ascending: false,
      sortProp: "timestamp",
      modal: "",
      req_type: "",
      cityVal: ""
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
    ...mapState(["allRequests", "bulksettings", "bulkTypes"]),
  },

  methods: {
    exportCSVFile() {
      this.$refs.RequestTable.csvExport(true);
    },
    resetPage() {
      this.$refs.RequestTable.updatePage(0);
    },
    sortBulkTypes(bulkTypes, dropEmpty=false) {
      const emptyData = [];
      var types = bulkTypes.filter(item => {
        if(item.name == "" || item.name == null) {
            emptyData.push(item)
            return false;
        }
        return true
      })

      types = types.sort(function (a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();

        if(textA < textB)
            return -1

        if(textA > textB) {
          return 1;
        }

        return 0;
      });

      if(!dropEmpty)
          return types.concat(emptyData);
      else {

        var removedEmpty = types.filter(item => {
        if(item.message == "" || item.message == null) {
            return false;
        }

        if(item.pickup == "" || item.pickup == null) {
            return false;
        }

        return true
      })

      return removedEmpty;

      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>